import React from "react";

import { HeadingWIcon } from "@molecules";
import { Image } from "@atoms";

const AllianceSection = ({ heading, copy, logos }) => {
  return (
    <div className="grid grid-cols-1 gap-6 py-12 sm:py-24 lg:gap-12">
      <HeadingWIcon
        heading={heading}
        copy={copy}
        colors={{ heading: "text-blue" }}
      />
      <div className="flex flex-wrap gap-6 md:flex-nowrap md:gap-12">
        {logos &&
          logos.length &&
          logos.map(l => (
            <div
              key={l.uid}
              className="h-12 w-auto flex-initial md:h-16 md:flex-grow"
            >
              {l.image && <Image image={l.image} fitHeight position="left" />}
            </div>
          ))}
      </div>
    </div>
  );
};

AllianceSection.defaultProps = {};

export default AllianceSection;
